import React from "react";
import CampaignBanner from "components/page/campaign/campaign-banner/CampaignBanner";
import DataContainer from "components/utility/data-container/DataContainer";

const CampaignBannerPage = ({ dataset }) => {
	return (
		<div>
			<DataContainer data={`campaignBanner${dataset.guid}`}>
				<CampaignBanner />
			</DataContainer>
		</div>
	);
};

export default CampaignBannerPage;
